export const constants = {
    LOAD_GO: "LOAD_GO",
    LOAD_GO_SUCCESS: "LOAD_GO_SUCCESS",
    LOAD_GO_FAILURE: "LOAD_GO_FAILURE",
}

export const loadGO = () => (dispatch) => {
    dispatch({ type: constants.LOAD_GO })
    const maxWaitTime = 300
    let currentWait = 0
    const goObserver = setInterval(() => {
        if (window.gaData) {
            dispatch({ type: constants.LOAD_GO_SUCCESS })
            clearInterval(goObserver)
        }
        if (currentWait >= maxWaitTime) {
            dispatch({ type: constants.LOAD_GO_FAILURE })
            clearInterval(goObserver)
        } else {
            currentWait++
        }
    }, 50)
}

export const loadingReducer = (state = false, action) => {
    switch (action.type) {
        case constants.LOAD_GO:
            return true
        case constants.LOAD_GO_SUCCESS:
        case constants.LOAD_GO_FAILURE:
            return false
        default:
            return state
    }
}